import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";

export const TenderProcessTableContainer = styled(Box)({
  width: "100%",
  maxWidth: "600px",
  margin: "0 auto",
  backgroundColor: "#fff",
  borderRadius: "8px",
  padding: "16px",
});

export const FileHeader = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  fontWeight: "600",
  color: "#6b7280",
  paddingBottom: "8px",
  borderBottom: "1px solid #e5e7eb",
});

export const FileRow = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  padding: "12px 0",
  borderBottom: "1px solid #e5e7eb",
  color: "#374151",
  "&:last-child": {
    borderBottom: "none",
  },
});

export const FileName = styled(Typography)({
  fontSize: "14px",
});

export const FileSize = styled(Typography)({
  fontSize: "14px",
  fontWeight: "bold",
});